<template>
  <div
    class="calico-tracker-item"
    @click="$emit('select', business)"
  >
    <div class="row">
      <!-- Risk-Level Badge -->
      <CalicoTierTrackerBadge
        :tier="badgeTier"
        :label="badgeLabel"
      />

      <div class="info">
        <div class="label--small">
          {{ business.name }}
        </div>
        <div class="business-address label--xsmall">
          {{ business.address }}
        </div>
      </div>

      <!-- Expiration -->
      <div
        v-if="!hideExpiration"
        class="expiration label--xsmall"
      >
        {{ business.daysRemaining }} Days
      </div>
    </div>
  </div>
</template>

<script>
import CalicoTierTrackerBadge from "@/components/calico/tierTrackerBadge/index.vue";
import { resolveTrackerTier } from "@/utils/trackerTier";

export default {
  name: "CalicoTrackerItem",
  components: { CalicoTierTrackerBadge },
  props: {
    business: { type: Object, required: true },
    hideExpiration: { type: Boolean, default: false }
  },
  computed: {
    badgeTier() {
      return resolveTrackerTier(this.business).className;
    },
    badgeLabel() {
      return resolveTrackerTier(this.business).label;
    }
  }
};
</script>

<style scoped lang="scss">
.calico-tracker-item {
  @include stack-space($space-xxsmall);
  cursor: pointer;
  background: transparent;
  border-bottom: 1px solid $color-neutral-light;

  transition: background 0.25s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    background: $color-black-lightest;

    .row {
      transform: translateX(2px);
    }
  }

  &:active {
    background: $color-black-light;
  }

  &:last-child {
    border-bottom: none;
  }

  .row {
    @include inline-space($space-medium);
    gap: $space-small;
    padding: $space-small;
    align-items: center;
    transform: translateX(0);
    transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);

    .info {
      @include stack-space($space-xsmall);
    }

    .label--small,
    .business-address {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .business-address {
      color: $color-neutral;
    }

    .expiration {
      margin-left: auto;
      white-space: nowrap;
      color: $color-black;
    }
  }
}
</style>
